<template>
    <main-layout>
        <template #submenu>
            <helm-chart-sub-menu :team="team" :chart="chart" active="versions"></helm-chart-sub-menu>
        </template>

        <template #breadcrumbs>
            <span class="union-icon">
                <i class="feather-tag"></i>
            </span>
            <span class="repo-chart-title">
                <inertia-link :href="route('home')">
                    <span class="repo-text">Repositories</span>
                </inertia-link>
                <span class="d-line">/ </span>
                <inertia-link :href="route('repository.view', {team: team})">
                    <span class="repo-text">{{ team.slug }}</span>
                </inertia-link>
                <span class="d-line">/ </span>
                <inertia-link :href="route('helm-chart.view', {team: team, helm_chart: chart})">
                    <span class="repo-text">{{ chart.chart_name }}</span>
                </inertia-link>
                <span class="d-line">/ </span>
                <span>Versions</span>
            </span>
        </template>
        <template #pageTitle>
            <h2 class="mb-1">Version history</h2>
            <span class="sm-text">Browse throught the past versions of your helm chart</span>
        </template>


        <div class="row g-0">
            <div class="col-lg">
                <div class="content-main">
                    <div class="table-style mt-0">
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                <tr>
                                    <th scope="col">Version</th>
                                    <th scope="col">App Version</th>
                                    <th scope="col">Release date</th>
                                    <th scope="col">Git commit</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="version in versions">
                                    <td class="td-content">
                                        <inertia-link :href="route('helm-chart.view-version', {team: team, helm_chart: chart, helm_chart_package: version })">
                                        {{ version.version }}
                                        </inertia-link>
                                    </td>
                                    <td class="td-content">{{ version.app_version }}</td>
                                    <td class="td-content">{{ dateFormating(version.updated_at) }}</td>
                                    <td class="td-content"  ></td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-auto">
                <div class="siderbar-right">
                </div>
            </div>
        </div>

    </main-layout>
</template>

<script>
    import MainLayout from "@/Layouts/MainLayout";
    import HelmChartSubMenu from "@/Components/HelmChartSubMenu";
    export default {
        name: "Versions",
        components: {HelmChartSubMenu, MainLayout},
        props: ['team', 'chart', 'versions'],
        methods: {
            dateFormating(date) {
                let newDate = new Intl.DateTimeFormat('en-GB', {dateStyle: 'medium'}).format(new Date(date));
                return newDate;
            },
        }
    }
</script>

<style scoped>

</style>
